import { render, staticRenderFns } from "./Imports.vue?vue&type=template&id=fa8c642c"
import script from "./Imports.vue?vue&type=script&lang=js"
export * from "./Imports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports